import React, { ReactElement } from "react";
import Tooltip from "./Tooltip";

interface FieldHeaderProps {
  title?: string;
  tooltipStr: string;
  number: number;
  extraCssClass?: string;
  clearAfter?: boolean;
  element: JSX.Element;
}

const FieldHeader = ({
  title,
  tooltipStr,
  number,
  extraCssClass = "",
  clearAfter = false,
  element,
}: FieldHeaderProps) => {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  return (
    <div
      className={`product-section__wrap product-section-pb ${extraCssClass}`}>
      <div
        className={`product-section__step ${clearAfter ? "clear-after " : ""}`}>
        <span className={"product-section__step-count"}>{`${number}`}</span>
      </div>
      <div className={"product-section__title-wrap"}>
        <p className={"product-section__title"}>{`${title} :`}</p>
        <Tooltip message={tooltipStr} />
      </div>
      {element}
    </div>
  );
};

export default FieldHeader;
